import { render } from "./purchase_order_detail.vue?vue&type=template&id=0243bad4&scoped=true"
import script from "./purchase_order_detail.vue?vue&type=script&lang=js"
export * from "./purchase_order_detail.vue?vue&type=script&lang=js"

import "./purchase_order_detail.vue?vue&type=style&index=0&id=0243bad4&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0243bad4"]])

export default __exports__